// MUI
import { Grid } from "@mui/material"

// Components
import AuthHeader from "src/components/layout/auth-header"
import LoginForm from "../components/login-form"
import AuthFooter from "src/components/layout/auth-footer"
import { useState } from "react"
import { AppLoading } from "../../../AppLoading"

// ----------------------------------------|| LOGIN - MOBILE ||------------------------------------------------------

const MobileLogin = ({ userData }) => {
  const [loading, setLoading] = useState(false)
  return (
    <Grid container sx={{ p: 2, minHeight: "100vh", background: "#fff" }} justifyContent='center' alignItems='center'>
      <Grid item xs={12}>
        {/* Login Header */}
        <AuthHeader page='login' title='ورود با کد یک بار مصرف' subTitle='لطفا شماره موبایل خود را وارد کنید' />

        {/* Login Form */}
        <LoginForm userData={userData} />

        {/*  Login Footer */}
        <AuthFooter page='register' />

        <AppLoading isLoading={loading} />
      </Grid>
    </Grid>
  )
}

export default MobileLogin
